var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('SectionTransformTable', [_c('SearchList', {
    attrs: {
      "title": _vm.$t('ar_client_list_receipt')
    },
    on: {
      "search": _vm.refetchData
    }
  }, [_c('FormItems', {
    attrs: {
      "formData": _vm.searchVal,
      "items": _vm.formItems
    },
    on: {
      "update:formData": function ($event) {
        _vm.searchVal = $event;
      },
      "update:form-data": function ($event) {
        _vm.searchVal = $event;
      }
    }
  })], 1), _c('b-card', [_c('EzTable', {
    ref: "tableRate",
    attrs: {
      "actionsConfig": {
        fixed: true
      },
      "selectionConfig": {
        hideSelectAll: true,
        hideSelect: !_vm.isValidPermission(_vm.AR_IDA01)
      },
      "dataSourceParams": _vm.searchVal,
      "excelExportApiCode": _vm.AR_RPA03,
      "excelExport": _vm.arClient.api_ExcelAR_RPA01,
      "actions": _vm.actions,
      "columns": _vm.columns,
      "dataSource": _vm.arClient.api_AR_RPA01
    },
    on: {
      "selection-changed": _vm.selectPayment,
      "action-1": _vm.viewDetailListVoucher,
      "action-2": function (data) {
        _vm.removeListArPay({
          ArPayment: {
            Id: data.data.Id
          }
        });
      }
    },
    scopedSlots: _vm._u([{
      key: "toolbar",
      fn: function () {
        return [_c('div', {
          staticClass: "d-flex"
        }, [_c('PermissionButton', {
          attrs: {
            "api-code": _vm.AR_IQA01,
            "variant": "outline-primary"
          },
          on: {
            "click": function () {
              return _vm.isShowQuickActionModal = true;
            }
          }
        }, [_c('ez-icon', {
          attrs: {
            "icon": "ezAr-icon-plus-circle"
          }
        }), _vm._v(" " + _vm._s(_vm.$t("ar_client_quick_create")) + " ")], 1), _c('b-dropdown', {
          class: {
            'd-none': !_vm.isValidPermission(_vm.AR_IDA01)
          },
          staticStyle: {
            "margin-left": "6px",
            "width": "140px"
          },
          attrs: {
            "id": "dropdown-left",
            "text": _vm.$t('ar_client_allotment'),
            "variant": "outline-primary"
          }
        }, [_c('b-dropdown-item', {
          staticClass: "text-wrap",
          attrs: {
            "href": "#"
          },
          on: {
            "click": _vm.distributePayment
          }
        }, [_vm._v(_vm._s(_vm.$t("ar_client_create_distribution")))])], 1), _c('PermissionButton', {
          staticStyle: {
            "margin-left": "6px"
          },
          attrs: {
            "api-code": _vm.AR_IPA01,
            "variant": "outline-primary"
          },
          on: {
            "click": _vm.showModalPopupAddNew
          }
        }, [_c('ez-icon', {
          attrs: {
            "icon": "ezAr-icon-plus-circle"
          }
        }), _vm._v(" " + _vm._s(_vm.$t("ar_common_add_new")) + " ")], 1)], 1)];
      },
      proxy: true
    }])
  })], 1), _vm.isShowQuickActionModal ? _c('ModalQuickAction', {
    attrs: {
      "isShow": _vm.isShowQuickActionModal
    },
    on: {
      "afterSave": function () {
        _vm.isShowQuickActionModal = false;
        _vm.refetchData();
      },
      "update:isShow": function ($event) {
        _vm.isShowQuickActionModal = $event;
      },
      "update:is-show": function ($event) {
        _vm.isShowQuickActionModal = $event;
      }
    }
  }) : _vm._e(), _c('ModalBoxAddNew', {
    attrs: {
      "billErrorCode": _vm.billErrorCode,
      "isShow": _vm.isShowModalAddNew,
      "data": _vm.dataRefill,
      "listCompany": _vm.dataArClient
    },
    on: {
      "update:isShow": function ($event) {
        _vm.isShowModalAddNew = $event;
      },
      "update:is-show": function ($event) {
        _vm.isShowModalAddNew = $event;
      },
      "accept-data": _vm.addDataBill,
      "accept-data-edit": _vm.addDataEdit
    }
  }), _c('SidebarViewPayment', {
    attrs: {
      "isUpdate": _vm.isUpdatePayment || _vm.isCreatePayment,
      "isDetailPaymentLoading": _vm.isFetchDetailDataLoading,
      "isShow": _vm.isShowDetailsInvoiceDetail,
      "data": _vm.dataViewDetailsPayment,
      "dataRefillForBill": _vm.dataRefillForBill,
      "listDataCashier": _vm.listCashier,
      "listPayment": _vm.listPayment,
      "listPaymentHistory": _vm.listPaymentHistory
    },
    on: {
      "update:isShow": function ($event) {
        _vm.isShowDetailsInvoiceDetail = $event;
      },
      "update:is-show": function ($event) {
        _vm.isShowDetailsInvoiceDetail = $event;
      },
      "update:dataRefillForBill": function ($event) {
        _vm.dataRefillForBill = $event;
      },
      "update:data-refill-for-bill": function ($event) {
        _vm.dataRefillForBill = $event;
      },
      "show-edit": _vm.showModalEditAddNew,
      "accept-data-bill": _vm.addListPaymentForinvoiceDetail,
      "show-edit-bill": _vm.fetchDataReadBill,
      "del-arpayment": _vm.removeListArPay,
      "del-ListArPaymentDetail": _vm.delListArPaymentDetail,
      "accept-data-edit": _vm.acceptEditForBillPayment
    }
  }), _vm.isShowModalDistributionAccount ? _c('ModalDistributionAccount', {
    attrs: {
      "disabled": _vm.isCreateDistribution,
      "visible": _vm.isShowModalDistributionAccount,
      "listDataSelected": _vm.listSelectedRow,
      "currencyCode": _vm.listSelectedRow.length > 0 ? _vm.listSelectedRow[0].CurrencyCode || '' : ''
    },
    on: {
      "update:visible": function ($event) {
        _vm.isShowModalDistributionAccount = $event;
      },
      "accept-data": _vm.acceptData_AR_IDA01
    }
  }) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }